import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { DataUsageSharp } from "@material-ui/icons";

const useStyles = makeStyles({
  table: {
    width: '100%',
  },
});

const BookingsListItem = (bookings) => {
  const classes = useStyles();

  const data = bookings.bookings;
  // console.log(data);

  var bookingDataAvailable = false;

  function loadingMessage() {
    return <h1>Loading</h1>
  }

  if (data) {
    bookingDataAvailable = true;
    // var owners = []; 
    // // let index = 0;
    // for(let i = 0; i < bookings.bookings.reservations.length; i++){
    //   let owner = bookings.bookings.reservations[i].owner.id.name;
    //   if(!owners.includes(owner)){
    //     eval('var ' + owner + '= ' + [] + ';');
    //     owners.push(owner);
    //   }
    // }
    // console.log(`owners:  ${JSON.stringify(owners)}`);
    // var owner_slots = {};
    // data.reservations.map((res) => {
    //   let name = res.owner.id.name;
    //   console.log(name);
    // })

  }

  return (
    bookingDataAvailable ?
      (
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Start time</TableCell>
                <TableCell align="left">Booked by</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.reservations.map((row) => (
                <TableRow>
                  <TableCell component="th" scope="row">
                    {
                      row.slot.number >= 12 ?
                        (
                          `${Number(row.slot.number) % 12 || 12} PM`
                        ) :
                        (
                          row.slot.number + "AM"
                        )
                    }
                  </TableCell>
                  {
                  row.owner && row.owner.id && row.owner.id.name ?
                    (<TableCell align="left">{row.owner.id.name}</TableCell>
                  ) :
                    (
                      <TableCell align="left">name</TableCell>
                    )
                  }
                  {/* <TableCell >{row.owner.id.companyDetails[0].companyName}</TableCell> */}
                  {/* <TableCell align="left">{row.owner.id.phone_number}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )
      :
      (loadingMessage)
  );
};

export default BookingsListItem;
